'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

var _detail = require('./detail');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _module = _angular2.default.module('app.fastOrder', []).config(["$stateProvider", function ($stateProvider) {
    'ngInject';

    $stateProvider.state('fast-order', {
        parent: 'general',
        url: '/fast-order',
        views: {
            'main@root': {
                component: 'fastOrderDetail'
            }
        },
        ncyBreadcrumb: {
            label: '{{"Fast order" | translate}}'
        }
    });
}]).component('fastOrderDetail', _detail.fastOrderDetailComponent);

exports.default = _module.name;


//////////////////
// WEBPACK FOOTER
// ./features/fast-order/index.js
// module id = 933
// module chunks = 0